import { COLORS } from '@btime/constants'
import { capitalizeSentenceIfLower } from '@btime/helpers'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Sticky from '../../../../components/helpers/Sticky'

const CategoryHeader = ({ category }) => {
  return (
    <Sticky bgColor={COLORS.white} zIndex={999}>
      <FlexGrid justify="space-between">
        <FlexCol flex={1}>
          <Title color={COLORS.dark2} size="h4" noMargin>
            {capitalizeSentenceIfLower(category.name)}
          </Title>
        </FlexCol>
      </FlexGrid>
    </Sticky>
  )
}

export default CategoryHeader
